import { Component } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { PersistenceService } from '../../../services/persistence.service';

@Component({
    selector: 'app-pg-login-handler-code',
    standalone: false,
    templateUrl: './pg-login-handler-code.component.html',
    styleUrl: './pg-login-handler-code.component.scss',
})
export class PgLoginHandlerCodeComponent {

    constructor(private authService:AuthService, private persistenceService:PersistenceService) {}

    isLoading = false;
    loginError = false;

    onLoginCodeKeyUp(event:KeyboardEvent) {
        if(event.key == 'Enter') {
            if(this.canLoginCode()) {
                this.doLoginCode();
            }
        }
    }

    loginCode:string = null;

    canLoginCode() {
        return this.loginCode != null && this.loginCode != '';
    }

    doLoginCode() {
        this.isLoading = true;
        this.loginError = false;

        this.authService.loginCode(this.loginCode).then(() => {
            this.isLoading = false;
            this.persistenceService.setItem('PGLoginStatus', JSON.stringify({
                mode: 'code'
            }), 'technical');
        }, () => {
            this.loginError = true;
            this.isLoading = false;
        })
    }
}
